export class RoleCustom {
    constructor(
        public ID: number,
        public Name: string,
        public IsSelected: boolean,
        public TradingPartnerID: number
    ) {
    }
}
